import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyCoinListDetails } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./CoinListDetailsPage.css";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const STATUS_CLASS = {
  pending: "coinlist-status--pending",
  approved: "coinlist-status--approved",
  rejected: "coinlist-status--rejected",
};

const CoinListDetailsPage = () => {
  const [list, setList] = useState(dummyCoinListDetails);
  const [viewItem, setViewItem] = useState(null);

  const handleStatusChange = (id, newStatus) => {
    setList((prev) =>
      prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item))
    );
    setViewItem(null);
  };

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Coin Listed Details</span>
          </p>
          <h1 className="dashboard-hero__title">Coin Listed Details</h1>
          <p className="dashboard-hero__subtitle">
            View and manage coin listing applications
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-chart-line" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="coinlist-section">
          <div className="coinlist-section__header">
            <div className="coinlist-section__title-wrap">
              <span className="coinlist-section__icon">
                <i className="fas fa-coins" />
              </span>
              <h2 className="coinlist-section__title">Coin List</h2>
            </div>
            <div className="coinlist-section__stats">
              <span className="coinlist-stat">
                <strong>{list.length}</strong> Total
              </span>
              <span className="coinlist-stat">
                <strong>{list.filter((i) => i.status === "pending").length}</strong> Pending
              </span>
              <span className="coinlist-stat">
                <strong>{list.filter((i) => i.status === "approved").length}</strong> Approved
              </span>
            </div>
          </div>
          <div className="coinlist-table-wrap">
            <table className="coinlist-table">
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Email</th>
                  <th>Contact Name</th>
                  <th>Telegram</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {list.map((row) => (
                  <tr key={row._id}>
                    <td>
                      <strong>{row.projectName}</strong>
                    </td>
                    <td>{row.emailId}</td>
                    <td>{row.ContactName}</td>
                    <td>{row.Telegram}</td>
                    <td>
                      <span className={`coinlist-status ${STATUS_CLASS[row.status] || ""}`}>
                        {row.status}
                      </span>
                    </td>
                    <td>{formatDate(row.createdAt)}</td>
                    <td>
                      <div className="coinlist-actions">
                        <button
                          type="button"
                          className="coinlist-btn coinlist-btn--view"
                          onClick={() => setViewItem(row)}
                          title="View"
                        >
                          <i className="fas fa-eye" /> View
                        </button>
                        {row.status === "pending" && (
                          <>
                            <button
                              type="button"
                              className="coinlist-btn coinlist-btn--approve"
                              onClick={() => handleStatusChange(row._id, "approved")}
                              title="Approve"
                            >
                              <i className="fas fa-check" /> Approve
                            </button>
                            <button
                              type="button"
                              className="coinlist-btn coinlist-btn--reject"
                              onClick={() => handleStatusChange(row._id, "rejected")}
                              title="Reject"
                            >
                              <i className="fas fa-times" /> Reject
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>

      {/* View detail modal */}
      {viewItem && (
        <div className="coinlist-modal-overlay" onClick={() => setViewItem(null)}>
          <div className="coinlist-modal" onClick={(e) => e.stopPropagation()}>
            <div className="coinlist-modal__header">
              <h3>{viewItem.projectName}</h3>
              <span className={`coinlist-status ${STATUS_CLASS[viewItem.status] || ""}`}>
                {viewItem.status}
              </span>
              <button
                type="button"
                className="coinlist-modal__close"
                onClick={() => setViewItem(null)}
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="coinlist-modal__body">
              <dl className="coinlist-dl">
                <div>
                  <dt>Project Name</dt>
                  <dd>{viewItem.projectName}</dd>
                </div>
                <div>
                  <dt>Email</dt>
                  <dd>{viewItem.emailId}</dd>
                </div>
                <div>
                  <dt>Contact Name</dt>
                  <dd>{viewItem.ContactName}</dd>
                </div>
                <div>
                  <dt>Country Code</dt>
                  <dd>{viewItem.countryCode}</dd>
                </div>
                <div>
                  <dt>Phone Number</dt>
                  <dd>{viewItem.phoneNumber}</dd>
                </div>
                <div>
                  <dt>Telegram</dt>
                  <dd>{viewItem.Telegram}</dd>
                </div>
                <div>
                  <dt>WhatsApp ID</dt>
                  <dd>{viewItem.WhatsappID}</dd>
                </div>
                <div>
                  <dt>Referred By</dt>
                  <dd>{viewItem.referredBy}</dd>
                </div>
                <div>
                  <dt>Smart Contract Address</dt>
                  <dd className="coinlist-dl__mono">{viewItem.smartContractAddress}</dd>
                </div>
                <div>
                  <dt>Comments</dt>
                  <dd>{viewItem.comments}</dd>
                </div>
                <div>
                  <dt>Created</dt>
                  <dd>{formatDate(viewItem.createdAt)}</dd>
                </div>
                <div>
                  <dt>Status</dt>
                  <dd>
                    <span className={`coinlist-status ${STATUS_CLASS[viewItem.status] || ""}`}>
                      {viewItem.status}
                    </span>
                  </dd>
                </div>
              </dl>
            </div>
            <div className="coinlist-modal__footer">
              {viewItem.status === "pending" && (
                <>
                  <button
                    type="button"
                    className="coinlist-btn coinlist-btn--approve"
                    onClick={() => handleStatusChange(viewItem._id, "approved")}
                  >
                    <i className="fas fa-check" /> Approve
                  </button>
                  <button
                    type="button"
                    className="coinlist-btn coinlist-btn--reject"
                    onClick={() => handleStatusChange(viewItem._id, "rejected")}
                  >
                    <i className="fas fa-times" /> Reject
                  </button>
                </>
              )}
              <button
                type="button"
                className="coinlist-btn coinlist-btn--secondary"
                onClick={() => setViewItem(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default CoinListDetailsPage;
